import React from 'react';
import __ from 'lodash';
import {NavLink, useHistory} from "react-router-dom";
import Menu from 'material-ui-popup-state/HoverMenu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import {usePopupState, bindHover, bindMenu} from 'material-ui-popup-state/hooks';
import {makeStyles, withStyles} from "@material-ui/core/styles";
import NestedMenu from "./NestedMenu";
import {Divider} from "@material-ui/core";


const StyledMenuItem = withStyles(theme => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
        '&:hover': {
            backgroundColor: theme.palette.primary.main //'rgba(0,0,0,0.2)'
        },
        '&.Mui-selected:hover': {
            backgroundColor: 'rgba(0,0,0,0.5)'
        },
    },
}))(MenuItem);

const HoverMenu = (props) => {

    const classes = makeStyles(theme => ({
        button: {
            "&:hover": {
                backgroundColor: theme.palette.primary.main
            },
        },
        paper: {
            border: '1px solid #d3d4d5',
            marginTop: -1
        },
    }))();

    const popupState = usePopupState({ variant: 'popover', popupId: 'demoMenu' });
    const history = useHistory();

    const handleMenuClick = event => {
            history.push(props.menuItems[0].path);
    };

    if (props.menuItems.length === 1) {
        return <React.Fragment>
            <Button
                className={classes.button}
                color="secondary"
                onClick={handleMenuClick}
                {...bindHover(popupState)}
            >
                {props.menuName}
            </Button>
        </React.Fragment>
    }
    else {
        return <React.Fragment>
            <Button
                className={classes.button}
                color="secondary"
                //onClick={handleMenuClick}
                //variant="contained"
                {...bindHover(popupState)}
            >
                {props.menuName}
            </Button>
            <Menu
                className={classes.paper}
                {...bindMenu(popupState)}
                getContentAnchorEl={null}
                anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                transformOrigin={{vertical: 'top', horizontal: 'left'}}
            >
                {
                    props.menuItems.map((menuItem) => {
                        if (menuItem.name === "Divider") {
                            return (
                                <Divider key={menuItem.id}/>
                            );
                        }
                        if (props.nestedItems && Array.isArray(props.nestedItems)) {
                            const menuNestedItems = __.filter(props.nestedItems, {parentId: menuItem.id});
                            if (menuNestedItems && Array.isArray(menuNestedItems) && menuNestedItems.length > 0) {
                                return (
                                  <NestedMenu id={menuItem.id} key={menuItem.id} selected={false} label={menuItem.name} parentMenuOpen={true}>
                                      {menuNestedItems.map(childItem => (
                                        <StyledMenuItem key={childItem.id} selected={false}>
                                            <NavLink to={childItem.path} isActive={()=>{return false}} activeStyle={{color: "#ffffff"}} style={{color: "#1b4481", textDecorationLine: "none"}}>{childItem.name}</NavLink>
                                        </StyledMenuItem>
                                      ))}
                                  </NestedMenu>
                                );
                            }
                        }
                        return (
                            <StyledMenuItem key={menuItem.id} selected={false} onClick={popupState.close}>
                                <NavLink
                                  to={menuItem.path}
                                  isActive={() => { return false }}
                                  activeStyle={{color: "#ffffff"}}
                                  style={{color: "#000000", textDecorationLine: "none"}}>{menuItem.name}
                                </NavLink>
                            </StyledMenuItem>
                        )
                    })
                }
            </Menu>
        </React.Fragment>
    }
}

export default HoverMenu;
